<template>
  <div>
    <shop-head currentPageName="qpgtt"></shop-head>
    <div class="content_wrapper">
      <div class="container">
        <div class="content">
          <div class="newsList">
            <div class="premium">
              <h1 style="font-weight: 500; color: #1684fc; line-height: 40px">
                {{ name }}
              </h1>
              <br />
              <p>{{ secondName }}</p>
              <br />
              <el-carousel height="300px">
                <el-carousel-item v-for="item in 1" :key="item">
                  <img v-if="type == '1'" :src="images" alt="" />
                  <video
                    v-else
                    width="100%"
                    height="100%"
                    :autoplay="true"
                    :src="videoUrl"
                    controls
                  ></video>
                </el-carousel-item>
              </el-carousel>
              <div class="send">
                <div style="line-height: 40px">
                  <el-button
                    size="mini"
                    icon="el-icon-thumb"
                    @click="praiseSave(null, 1)"
                    >点赞</el-button
                  >
                  <el-button
                    size="mini"
                    icon="el-icon-star-off"
                    @click="collectSave"
                    >收藏</el-button
                  >
                  <el-button size="mini" icon="el-icon-share" @click="share"
                    >分享</el-button
                  >
                </div>
                <div>
                  <el-input
                    placeholder="评论"
                    size="normal"
                    clearable
                    v-model="commmentContent"
                  >
                    <el-button slot="append" @click="commmentSave">
                      发送</el-button
                    >
                  </el-input>
                </div>
              </div>
            </div>
            <div style="width: 100%">
              <h1></h1>
              <div>
                <span>{{ leagueName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <el-button type="text" size=""> {{ author }} </el-button>
                <span
                  >&nbsp;&nbsp;&nbsp;&nbsp;{{ updateTime | formatDate }}</span
                >
              </div>
              <br />
              <div class="details" v-if="type == '1'">
                <Editor
                  v-model="videoUrl"
                  style="height: 500px; overflow-y: auto"
                  :defaultConfig="editorConfig"
                  @onCreated="onCreated"
                />
                <!-- {{ details || '' }} -->
              </div>
              <br />
              <h2 style="font-weight: 600">
                评论列表 ({{ this.commentCount }}条)
              </h2>
              <br />
              <div class="comments">
                <el-row :gutter="20" v-for="item in comments" :key="item.id">
                  <el-col :span="3" :offset="0">
                    <img :src="item.avatar" alt="" />
                  </el-col>
                  <el-col :span="19" :offset="0">
                    <b>{{ item.userName }}</b>
                    <p>{{ item.content }}</p>
                    <p>{{ item.createTime | formatDate }}</p>
                  </el-col>
                  <el-col :span="2" :offset="0">
                    <el-button
                      style="border: none"
                      icon="el-icon-thumb"
                      @click="praiseSave(item.id, 2)"
                    ></el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
            <br />
            <el-pagination
              background
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="commentCount"
              @size-change="handleChangeSize"
              @current-change="handleSearch"
            />
            <br />
          </div>
          <div class="hots">
            <h2 style="border-bottom: 3px solid #184d7f">
              {{ $t("热门资讯") }}
            </h2>
            <el-row
              :gutter="20"
              v-for="item in newsList"
              :key="item.id"
              style="margin-bottom: 20px; padding-bottom: 10px"
            >
              <div @click="goDetail(item)">
                <b style="padding: 0px 10px; display: block">{{ item.name }}</b>

                <el-col :span="10" :offset="0">
                  <img
                    style="width: 100%; height: 100px"
                    :src="item.images"
                    alt=""
                /></el-col>
                <el-col :span="14" :offset="0">
                  <p>{{ item.details }}</p>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {
  getnewsList,
  getnewsdetail,
  commmentFind,
  commmentSave,
  collectSave,
  collectUnSave,
  praiseSave,
  praiseUnSave,
} from "../../apis/qpgtt";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
    Editor,
    Toolbar,
  },
  filters: {
    formatDate(time) {
      return time ? new Date(+time).toLocaleString() : "--";
    },
  },
  data() {
    return {
      ...this.$route.query,
      editor: null,
      editorConfig: { readOnly: true },
      commentCount: 0,
      currentPage: 1,
      pageSize: 10,
      videoUrl: "",
      search: {
        name: "",
        type: "",
        status: "",
        sortAs: "BROWSE_TIMES desc",
        currentPage: 1,
        pageSize: 10,
      },
      commmentContent: "",
      newsList: [],
      comments: [],
    };
  },
  created() {
    this.getList();
    this.getComments();
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    goDetail(data) {
      this.$router.replace({
        path: "/newsDetail",
        query: data,
      });
      this.$router.go(0);
    },
    async getList() {
      this.newsList = (
        await getnewsList({
          name: "",
          type: "",
        })
      ).data.list;
      this.videoUrl = (await getnewsdetail({ id: this.id })).data.details;
    },
    async getComments() {
      const { list, total } = (await commmentFind({ objId: this.id })).data;
      this.comments = list;
      this.commentCount = total;
    },
    //点赞
    async praiseSave(objId, type) {
      try {
        const res = await praiseSave({ objId: objId || this.id, type });
        if (res.code == 200) {
          this.$message({
            message: "点赞成功",
            type: "success",
          });
        } else {
          this.$confirm("是否取消点赞", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(async () => {
            await praiseUnSave({ id: this.id });
            this.$message({
              message: "取消点赞成功",
              type: "success",
            });
          });
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "error",
        });
      }
    },
    //收藏
    async collectSave() {
      try {
        const res = await collectSave({ objId: this.id, type: 1 });
        if (res.code == 200) {
          this.$message({
            message: "收藏成功",
            type: "success",
          });
        } else {
          this.$confirm("是否取消收藏", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(async () => {
            await collectUnSave({ id: this.id });
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
          });
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "error",
        });
      }
    },
    //分享
    share() {
      const textArea = document.createElement("textarea");
      textArea.value = window.location.href.split("&")[0]; // 获取当前 URL
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$message({
        message: "复制分享链接成功!",
        type: "success",
      });
    },
    async commmentSave() {
      if (!this.commmentContent || !this.id) {
        this.$message({
          message: "评论内容不可为空",
          type: "warning",
        });
        return;
      }
      await commmentSave({
        objId: this.id,
        content: this.commmentContent,
      });
      this.getComments();
      this.$message({
        message: "评论成功",
        type: "success",
      });
    },

    handleChangeSize(value) {
      this.pageSize = value;
      this.search.pageSize = value;
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.search.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.getComments();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;

  ::v-deep .el-radio-button__inner {
    font-size: 16px;
    padding: 15px 275px;
  }

  .content {
    display: flex;

    .newsList {
      width: 70%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .premium {
        margin-bottom: 20px;
        width: 100%;

        .el-carousel__item img {
          width: 100%;
          height: 100%;
          line-height: 300px;
          margin: 0;
        }

        .send {
          width: 100%;
          padding: 5px 15px;
          background-color: #18171a;
          display: flex;
          justify-content: space-between;
          align-content: center;

          .el-input-group__append > .el-button--default {
            background-color: #fe3355 !important;
            border: none;
            color: #fff;
          }

          div {
            .el-button {
              background-color: #18171a00;
              border: none;
              color: #fff;
            }
          }
        }
      }

      ::v-deep .details {
        img {
          width: 100%;
        }
      }

      .comments {
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 20px;
        height: 1000px;

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
    }

    .hots {
      width: 30%;
      padding-left: 5px;
      overflow: hidden;
    }
  }
}
</style>